<template>
  <div class="fileListContainer">
    <YKDivider>
      <div style="width: 100%; display: flex;justify-content: space-between;align-items: center; flex: none">
        <div>附件</div>
        <div v-show="!isDisabled">
          <el-button size="text" @click="handleUpload">上传</el-button>
        </div>
      </div>
    </YKDivider>
    <div class="fileListTableContainer">
      <div class="fileItem" v-for="(item, index) of tableData" :key="index">
        <div class="fileItemName">
          <i style="font-size: 16px" class="el-icon-document" />
          &nbsp;
          <el-tooltip effect="dark" :content="item.display + item.type" placement="left">
            <span class="opeartionLink" @click="handleDown(item)">{{ item.display + item.type }}</span>
          </el-tooltip>
        </div>
        <div class="fileItemBtn">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-view"
            circle
            v-if="ID > 0 && isImageFile(item.type)"
            @click="previewImg(item)"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            v-if="!isDisabled"
            @click="handleDeleteFile(item)"
          ></el-button>
        </div>
        <div class="fileItemCreateInfo">
          <div class="fileItemCreater">{{ item.eName }}</div>
          <div class="fileItemCreateTime">{{ ykDateFormat('yyyy-MM-dd HH:mm:ss', item.uploadTime) }}</div>
        </div>
      </div>

      <div class="emptyFile" v-if="tableData.length === 0">
        <div>
          <img src="../../assets/img/null-data.png" />
          <div>- 暂无附件 -</div>
        </div>
      </div>
    </div>

    <div class="pdf-container"></div>

    <!-- 选择文件夹 -->
    <input type="file" ref="uploadRef" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
    <!-- 生成图片进度框 -->
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>
  </div>
</template>
<script>
import YKDivider from '../common/YKDivider.vue'

const baseUrl = {}

// sleep方法
function sleepPromise() {
  let resolve, reject
  let result = new Promise((res, rej) => {
    resolve = res
    reject = rej
  })
  result.resolve = resolve
  result.reject = reject
  return result
}

function timeSleep(duration) {
  let result = sleepPromise()
  result.timeoutID = setTimeout(result.resolve, duration)
  return result
}

export default {
  components: {
    YKDivider
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    vuePath: {
      type: String,
      default: ''
    },
    ID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 右键操作
      bodyMenus: [
        [
          {
            code: 'delete',
            name: '删除'
          }
        ]
      ],
      // 数据
      tableData: [],
      // 列
      gridColumns: [
        {
          field: 'fileName',
          title: '文件名',
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        }
      ],
      // 右键缓存
      areas: {},
      colProperty: '',
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
      // 缓存的文件列表
      cacheFileList: [],
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 上传信息
      arrayUpload: [],
      // 上传排序时间戳列表
      uploadTimeList: []
    }
  },
  methods: {
    // 获取缓存的文件列表
    getCacheFileList() {
      return this.cacheFileList
    },
    // 初始化
    init() {
      this.tableData = []
      this.cacheFileList = []

      if (this.ID > 0) {
        this.getFileListByApi()
      }
    },
    // 从数据库中获取文件列表
    async getFileListByApi() {
      const { data: res } = await this.$http.post('/base/attachment', {
        vuePath: this.vuePath,
        keyValue: this.ID
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data
    },
    // 判断文件是否为图片
    isImageFile(inputType) {
      const type = inputType.toLowerCase()

      // 支持的图片后缀名列表
      const imageExtensions = [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.bmp',
        '.xbm',
        '.tif',
        '.pjp',
        '.apng',
        '.svgz',
        '.ico',
        '.tiff',
        '.svg',
        '.jfif',
        '.webp',
        '.pjpeg',
        '.avif',
        '.pdf'
      ]

      // 判断文件后缀名是否为图片
      if (imageExtensions.includes(type)) {
        return true
      } else {
        return false
      }
    },
    // 提交缓存至服务器
    async handleUploadCacheFileToDB() {
      if (this.cacheFileList.length > 0) {
        this.fileCount = this.cacheFileList.length

        this.handleUploadFile(this.cacheFileList)
      }
    },
    // 删除一个文件
    handleDeleteFile(row) {
      if (this.ID) {
        // 如果有ID直接删除
        this.deleteFileByDB(row)
      } else {
        this.deleteFileByCache(row)
      }
    },
    // 从缓存中删除
    deleteFileByCache(row) {
      // 没有ID删除缓存
      // 显示部分
      const sIndex = this.tableData.findIndex(item => item.uuid === row.uuid)
      this.tableData.splice(sIndex, 1)
      // 缓存部分
      const cIndex = this.cacheFileList.findIndex(item => item.uuid === row.uuid)
      this.cacheFileList.splice(cIndex, 1)
    },
    // 从库中删除
    async deleteFileByDB(row) {
      if (this.vuePath === 'ReportApprove') {
        // 此处判断是否删除后还有pdf
        const judegeList = this.tableData.filter(item => item.id !== row.id).map(item => item.display + item.type)

        const flag = judegeList.some(fileName => fileName.toLowerCase().endsWith('.pdf'))

        if (!flag) {
          this.$message.error('删除失败! 报告中必须包含一个PDF')
          return
        }
      }

      const { data: res } = await this.$http.delete(`/base/attachment/${row.id}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('删除成功')
      this.init()
    },
    // 触发上传
    handleUpload() {
      this.$refs.uploadRef.click()
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    // 处理文件
    handleUploadFile(files) {
      let that = this

      if (files.length === 0) {
        return
      }

      that.completeList = []
      that.arrayUpload = []
      that.percentage = 0
      that.showProress = true
      that.processStr = `${that.percentage}%`

      for (let i = files.length - 1; i >= 0; i--) {
        const fileObj = files[i]
        that.uploadSingle(fileObj)
      }
    },
    /**
     * 上传
     */
    async uploadFile(event) {
      let that = this

      that.fileCount = event.target.files.length
      if (that.fileCount === 0) {
        return
      }

      let files = []
      // let allowedExtensions

      // if (this.vuePath === 'ReportApprove') {
      //   allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.xbm|\.tif|\.pjp|\.apng|\.svgz|\.ico|\.tiff|\.svg|\.jfif|\.webp|\.pjpeg|\.avif|\.pdf)$/i
      // } else {
      //   allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.xbm|\.tif|\.pjp|\.apng|\.svgz|\.ico|\.tiff|\.svg|\.jfif|\.webp|\.pjpeg|\.avif)$/i
      // }

      for (const item of event.target.files) {
        // if (allowedExtensions.test(item.name)) {
        // 缓存时间
        this.uploadTimeList.push({
          name: item.name,
          uploadTime: new Date().getTime() + ''
        })

        await timeSleep(10) // 等待10ms

        files.push(item)
        // }
      }

      // if (files.length !== event.target.files.length) {
      //   this.$message.warning('附件仅能上传图片, 已将非图片文件过滤')
      // }

      if (this.ID) {
        this.handleUploadFile(files)
      } else {
        // 没有id缓存需要上传的文件
        const tableData = []

        for (const item of files) {
          item.uuid = this.genreactUUID()
          const fileName = item.name + ''

          tableData.push({
            display: fileName,
            type: '',
            uuid: item.uuid
          })

          this.cacheFileList.push(item)
        }

        this.tableData = [...this.tableData, ...tableData]
      }
      event.target.value = ''
    },
    // 上传一个文件
    uploadSingle(fileObj) {
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      // 代理模式下， 通过代理走上传
      if (upload.includes('127.0.0.1:')) {
        upload = upload + '/nginxUpload'
      }
      const that = this
      const guID = that.genreactUUID()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', this.vuePath)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 计算总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = this.$utils.round(this.$utils.divide(sumPre, that.fileCount), 0)
      that.processStr = `${that.percentage}%`
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      const fileList = that.completeList.map(item => {
        let uploadTime = new Date().getTime + ''

        const uploadTimeIndex = that.uploadTimeList.findIndex(fi => {
          return fi.name === item.aDisplay + item.aType
        })

        if (uploadTimeIndex > -1) {
          uploadTime = that.uploadTimeList[uploadTimeIndex]['uploadTime'] // 获取时间

          that.uploadTimeList.splice(uploadTimeIndex, 1) // 删除缓存
        }

        const temp = {
          aKeyValue: that.ID,
          aName: item.aName,
          aDisplay: item.aDisplay,
          aClass: item.aClass,
          aPath: item.aPath,
          aType: item.aType,
          aSize: item.aSize,
          aLength: item.aLength,
          sort: uploadTime
        }
        return temp
      })
      const { data: res } = await that.$http.post(`/base/attachment/bulk-insert`, fileList)
      if (res.isSuccess) {
        that.$message.success('上传成功')

        // 报告调用预签字
        if (this.vuePath === 'ReportApprove') {
          this.$emit('PreSignature')
        }

        // that.$parent.refresh()
        that.init()
      } else {
        that.$message.error(res.errorMessage)
      }
      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    // 预览图片
    async previewImg(row) {
      const fileName = row.display + row.type

      let that = this
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      const { data: res } = await that.$http.get(`/base/attachment/secret`, {
        params: {
          urlstr: `${upload}/download/${row.filePath}`
        }
      })

      if (fileName.toLowerCase().endsWith('.pdf')) {
        // console.log(String(res).replace('http://localhost:8080', 'http://112.51.29.52:60000'))
        // 测试用的?
        window.open(String(res).replace('http://192.168.103.19:8080', 'http://112.51.29.52:60000'), '_blank')
      } else {
        this.$hevueImgPreview(res)
      }
    },
    // 下载
    async handleDown(row) {
      let that = this
      if (that.ID <= 0) {
        return
      }
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      const { data: res } = await that.$http.get(`/base/attachment/secret`, {
        params: {
          urlstr: `${upload}/download/${row.filePath}`
        }
      })
      // let aFileType = row.type.toUpperCase()
      // if (['HTML', 'TXT', 'JPG', 'JPEG', 'PNG', 'JIFF', 'ART', 'AU', 'AIFF', 'XBM', 'PDF'].includes(aFileType)) {
      //   const a = document.createElement('a')

      //   const url = res // 完整的url则直接使用
      //   // 这里是将url转成blob地址，
      //   fetch(url)
      //     .then(res => res.blob())
      //     .then(blob => {
      //       // 将链接地址字符内容转变成blob地址
      //       a.href = URL.createObjectURL(blob)
      //       a.download = row.display + '.' + row.type // 下载文件的名字
      //       // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
      //       document.body.appendChild(a)
      //       a.click()
      //     })
      // } else {
      let eleLink = document.createElement('a')
      eleLink.href = res
      eleLink.target = '_blank'
      eleLink.download = row.display + '.' + row.type
      eleLink.click()

      eleLink.remove()
      // }
    }
  }
}
</script>
<style lang="less" scoped>
@buttonHeight: 40px;

.fileListContainer {
  width: 100%;
  height: 100%;
}
.fileListTableContainer {
  margin-top: 10px;
  height: calc(100% - @buttonHeight - 10px);
  border-radius: 10px;
  background-color: #eee;

  box-sizing: border-box;
  padding: 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }

  .emptyFile {
    height: 100%;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: '#bebebe';

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      div {
        width: 100%;
      }

      img {
        width: 60%;
      }
    }
  }
}

.fileItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  // margin-bottom: 5px;

  font-size: 14px;

  border-radius: 5px;
  border: 1px solid #fff;
  box-shadow: 0px 0px 3px #b9b7b7;

  box-sizing: border-box;
  padding: 3px;
  background-color: #fff;

  transition: border 0.3s;

  &:hover {
    border: 1px solid #409eff;
  }
}

.fileItem + .fileItem {
  margin-top: 8px;
}

.opeartionLink {
  cursor: pointer;
}

.fileItemName {
  width: calc(100% - 65px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.fileItemBtn {
  width: 65px;
  display: flex;
  justify-content: flex-end;
}

.fileItemCreateInfo {
  width: 100%;
  display: flex;
  justify-content: space-between;

  color: #999;
  font-size: 12px;

  margin-top: 3px;
}

.el-button + .el-button {
  margin-left: 5px;
}
</style>
